<div class="assistant-sub-header">
  {{ assistantContent.preferences }}
</div>
<div class="assistant-bullets" data-cy="assistant-bullets" *ngIf="slackProperties">
  <div *ngFor="let bullet of bulletsContent">
    <div class="bullet">
      <div class="title">
        <u-icon *ngIf="bullet.icon" [model]="bullet.icon" [styles]="{ display: 'flex', fontSize: '10px' }"></u-icon>
        <span>{{ bullet.description }}</span>
        <u-emoji *ngIf="bullet.emoji" [spriteEmojiSize]="16" [unicode]="bullet.emoji"></u-emoji>
        <span *ngIf="bullet.descriptionAfterEmoji">{{ bullet.descriptionAfterEmoji }}</span>
        <u-icon
          *ngIf="bullet.displayInfoIcon"
          [model]="{ type: 'font', value: 'icon-info' }"
          [styles]="{ color: 'var(--color-primary)', fontSize: '14px' }"
          [pTooltip]="bullet.infoTooltip"
          class="bullet-title-info-icon"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          (click)="onClickInfoIcon(bullet.type)"
        ></u-icon>
      </div>
      <div class="bullet-actions-container">
        <ng-container *ngTemplateOutlet="bulletAdvancedAction; context: { bullet }"></ng-container>
        <u-toggle-switch
          [disabled]="viewOnly"
          [checked]="assistantBullets[bullet.type]"
          debounceClick
          type="small"
          (onChange)="onUpdateSync($event, bullet.type)"
        ></u-toggle-switch>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="bulletPanelAction; context: { bullet }"></ng-container>
    @if (
      bullet?.options?.length && assistantBullets?.[bullet.type] && (bullet.type !== 'enableExpertsValidation' || selectedExperts?.length)
    ) {
      <div class="options-section">
        @for (option of bullet?.options; track option) {
          <div class="title">
            <u-checkbox
              [checked]="assistantBullets?.[option.type]"
              [disabled]="viewOnly"
              [binary]="true"
              (onChange)="onUpdateSync($event, option.type)"
            >
            </u-checkbox>
            <span>{{ option.description }}</span>
            <u-emoji *ngIf="option.emoji" [spriteEmojiSize]="16" [unicode]="option.emoji"></u-emoji>
            <span *ngIf="option.descriptionAfterEmoji">{{ option.descriptionAfterEmoji }}</span>
          </div>
        }
      </div>
    }
  </div>
</div>

<ng-template #bulletAdvancedAction let-bullet="bullet">
  <div class="bullet-advanced-action" *ngIf="assistantBullets?.[bullet.type]">
    <span *ngIf="bullet.actionInfo?.preText">{{ bullet.actionInfo.preText }}</span>
    <ng-container [ngSwitch]="bullet.type">
      <ng-container *ngSwitchCase="'enableExpertsValidation'">
        <u-multi-select
          [model]="validationExpertsMultiselect"
          [styles]="{ width: 'fit-content', minWidth: '162px' }"
          placeholder="Select expert (required)"
          filterPlaceholder="Search Expert"
          [disabled]="viewOnly"
          class="experts-validation-multi-select"
          [multiSelectIcon]="{ type: 'font-icon', value: 'icon-user-circle' }"
          (onSelectedChange)="onSelectExpertsChanged($event)"
          [(ngModel)]="selectedExperts"
          [isNoColorCheckbox]="true"
          [limitShowSelectedLabels]="2"
          [maxSelectedLabelLength]="24"
        >
          <ng-template let-item pTemplate="item">
            <div class="experts-validation-multi-select-item">
              <span>{{ item.name }}</span>
              <span class="experts-validation-subtitle" *ngIf="item.email">{{ item.email }}</span>
            </div>
          </ng-template>
        </u-multi-select>
      </ng-container>
      <ng-container *ngSwitchCase="'enableRelatedQuestions'">
        <u-input-number
          [maxValue]="LIMIT_RELATED_QUESTION_MAX"
          [minValue]="LIMIT_RELATED_QUESTION_MIN"
          [styles]="{ width: '28px', height: '28px' }"
          [inputModel]="relateQuestionLimit"
          [disabled]="viewOnly"
          [resetToMaxOnClickOut]="true"
          (onChange)="changeRelatedQuestionsLimit($event)"
        >
        </u-input-number>
      </ng-container>
      <ng-container *ngSwitchCase="'enableRelatedArticles'">
        <u-input-number
          [maxValue]="LIMIT_RELATED_ARTICLES_MAX"
          [minValue]="LIMIT_RELATED_ARTICLES_MIN"
          [styles]="{ width: '28px', height: '28px' }"
          [inputModel]="knowledgeResourcesLimit"
          [disabled]="viewOnly"
          [resetToMaxOnClickOut]="true"
          (onChange)="changeRelatedArticlesLimit($event)"
        >
        </u-input-number>
      </ng-container>
      <ng-container *ngSwitchCase="'actionButtonCustomization'">
        <u-button
          [versionNumber]="2"
          fontIcon="eye"
          [typeElement]="'secondary'"
          [stateElement]="isValidCustomSuggestionActions() ? 'regular' : 'disabled'"
          [sizeElement]="'large'"
          [pTooltip]="'See how your customizations will appear in Slack'"
          tooltipPosition="top"
          tooltipStyleClass="u-tooltip"
          (onClick)="openPreviewPopup()"
        ></u-button>
      </ng-container>
    </ng-container>
    <span *ngIf="bullet.actionInfo?.postText">{{ bullet.actionInfo.postText }}</span>
  </div>
</ng-template>

<ng-template #bulletPanelAction let-bullet="bullet">
  @if (assistantBullets?.[bullet.type]) {
    @switch (bullet.type) {
      @case ('actionButtonCustomization') {
        @if (slackCustomSuggestionsInputs()?.length) {
          <div class="customization-panel-actions">
            @for (input of slackCustomSuggestionsInputs(); track input.text; let first = $first,index = $index) {
              <div class="customization-input-container">
                <span class="title">{{ input.text }}</span>
                <u-input
                  [model]="input.content"
                  (onChange)="onCustomSuggestionsInputsChanged($event, index)"
                  (onBlur)="onCustomSuggestionsInputsBlur()"
                  (onFocus)="onCustomSuggestionsInputsFocus($event, index)"
                  inputSize="small"
                  [placeholder]="input.placeholder"
                  [readonly]="viewOnly"
                  [showOverflowTooltip]="true"
                  [maxlength]="first ? TITLE_CHARS_LIMIT : DESCRIPTION_CHARS_LIMIT"
                  [errorTextOnly]="inputsErrors()[index]"
                  (keydown.enter)="$event.stopPropagation()"
                ></u-input>
              </div>
            }
          </div>
        }
        <slack-customization-inputs-list
          [initialModel]="slackCustomSuggestionActions()"
          (modelChanged)="onCustomSuggestionsActionsChanged($event)"
          [readonly]="viewOnly"
        ></slack-customization-inputs-list>
      }
    }
  }
</ng-template>
